import StatCard from "@shared/ui/stat-card/stat-card";
import { GrScorecard } from "react-icons/gr";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "./card-stats.scss";
import { GetBranchDailyModelV2 } from "@core/model/query-model-report";
import { DashboardMetadata } from "@core/model/dashboard-metadata.interface";
import { Sidebar } from "primereact/sidebar";
import { useState } from "react";
import { LabelValue } from "@shared/models/label-value.interface";
import { useNavigate } from "react-router-dom";

/* eslint-disable-next-line */
export interface CardStatsProps {
  data?: GetBranchDailyModelV2;
}

export function CardStats({ data }: CardStatsProps) {
  // DECLARATIONS
  const navigate = useNavigate();
  const [visibleList, setVisibleList] = useState(false);
  const [selectedList, setSelectedList] =
    useState<LabelValue<DashboardMetadata[]>>();

  // LOCAL FUNCTIONS
  const handleClick = (label: string, value: string | number) => {
    let valueArray = [] as DashboardMetadata[];
    switch (label) {
      case "Employees On Duty":
        valueArray = (data?.onduty_metadata || []) as DashboardMetadata[];
        break;
      case "Employees On Leave":
        valueArray = (data?.onleave_metadata || []) as DashboardMetadata[];
        break;
      case "Employees Absent":
        valueArray = (data?.absent_metadata || []) as DashboardMetadata[];
        break;
      case "Employees On Incident":
        valueArray = (data?.incident_metadata || []) as DashboardMetadata[];
        break;
      case "Employees Suspended":
        valueArray = (data?.suspend_metadata || []) as DashboardMetadata[];
        break;
      case "Pending Request":
        valueArray = (data?.pending_metadata || []) as DashboardMetadata[];
        break;
      case "Approved Request":
        valueArray = (data?.approved_metadata || []) as DashboardMetadata[];
        break;
      case "Rejected Request":
        valueArray = (data?.rejected_metadata || []) as DashboardMetadata[];
        break;
    }

    setSelectedList({ label, value: valueArray });
    setVisibleList(true);
  };
  const handlePersonView = (branch: string, userCode: string) => {
    navigate(`employee/${branch}/${userCode}`);
  };

  // RENDER
  const listData = (
    <Sidebar visible={visibleList} onHide={() => setVisibleList(false)}>
      <h2 className="mb-4">{selectedList?.label}</h2>
      <ul>
        {selectedList?.value.map((item, i) => (
          <li
            className="p-2 bg-gray-200 rounded mb-2 cursor-pointer"
            onClick={() => handlePersonView(item.branch_code, item.user_code)}
          >
            {i + 1}: {item.person_first_name} {item.person_last_name}
          </li>
        ))}
      </ul>
    </Sidebar>
  );

  const reportElement = (
    <section className="w-full">
      <section className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
        <StatCard
          label="Employees On Duty"
          value={data?.onduty || 0}
          icon={
            <div className="bg-green-200 p-4 rounded-lg">
              <GrScorecard />
            </div>
          }
          onClick={handleClick}
        />
        <StatCard
          label="Employees On Leave"
          value={data?.onleave || 0}
          icon={
            <div className="bg-amber-200 p-4 rounded-lg">
              <GrScorecard />
            </div>
          }
          onClick={handleClick}
        />
        <StatCard
          label="Employees Absent"
          value={data?.absent || 0}
          icon={
            <div className="bg-rose-200 p-4 rounded-lg">
              <GrScorecard />
            </div>
          }
          onClick={handleClick}
        />
        <StatCard
          label="Employees On Incident"
          value={data?.incident || 0}
          icon={
            <div className="bg-sky-200 p-4 rounded-lg">
              <GrScorecard />
            </div>
          }
          onClick={handleClick}
        />
        <StatCard
          label="Employees Suspended"
          value={data?.suspend || 0}
          icon={
            <div className="bg-violet-200 p-4 rounded-lg">
              <GrScorecard />
            </div>
          }
          onClick={handleClick}
        />
        <StatCard
          label="Employees Average Score"
          value={data?.score || 0}
          icon={
            <div className="bg-lime-200 p-4 rounded-lg">
              <GrScorecard />
            </div>
          }
          onClick={handleClick}
        />
        <StatCard
          label="Pending Request"
          value={data?.pending_request || 0}
          icon={
            <div className="bg-blue-400 p-4 rounded-lg">
              <GrScorecard />
            </div>
          }
          onClick={handleClick}
        />
        <StatCard
          label="Approved Request"
          value={data?.approved_request || 0}
          icon={
            <div className="bg-lime-400 p-4 rounded-lg">
              <GrScorecard />
            </div>
          }
          onClick={handleClick}
        />
        <StatCard
          label="Rejected Request"
          value={data?.rejected_request || 0}
          icon={
            <div className="bg-red-400 p-4 rounded-lg">
              <GrScorecard />
            </div>
          }
          onClick={handleClick}
        />
      </section>
      <section className="grid grid-cols-1 gap-6 mt-8">
        <h3>Birthday Celebrants</h3>
        {data?.birthdays ? (
          <DataTable value={data?.birthdays} tableStyle={{ minWidth: "50rem" }}>
            <Column
              body={(cell) =>
                `${cell.person_first_name} ${cell.person_last_name}`
              }
              header="Name"
            ></Column>
            <Column field="birthday" header="Birthday"></Column>
          </DataTable>
        ) : (
          <small className="text-center my-8">No Birthday Celebrants</small>
        )}
      </section>
    </section>
  );

  return (
    <div id="CardStats" className="card-stats">
      {listData}

      {reportElement}
    </div>
  );
}

export default CardStats;
